// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contactsWrapper {
    /* border-bottom: 1px solid #3ACABA; */
    border-bottom: 1px solid var(--main-green-color);
}
.contactsWrapper_title {
    display: flex;
    justify-content: space-between;
    padding-right: 32px;
    margin-bottom: 16px;
    width: 25%;
    padding-bottom: 24px;
    align-items: center;
}
.contactsWrapper_title h2 {
    display: block;
    color: #c2c7cc;
    font-family: Open Sans;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
}
.slider {
    position: relative;
}
.slider .prevArrow, .slider .nextArrow {
    position: absolute;
    /* fill: #3ACABA; */
    fill: var(--main-green-color);
    top: 50%;
    transform: translateY(-50%);
    font-size: 24px;
    background: transparent;
    border: none;
    cursor: pointer;
    transition: fill 0.3s ease, color 0.3s ease;
}
.slider .prevArrow:hover, .slider .nextArrow:hover {
    fill: rgb(44, 45, 46);
}
@media (max-width: 768px) {
    /* .slider .prevArrow, .slider .nextArrow {
        display: none;
   } */
}
.slider .prevArrow {
    /* left: 370px; */
    z-index: 1;
    top: 45%;
}
.slider .nextArrow {
    /* right: 420px; */
    top: 45%;
    z-index: 1;
}

.active_slide{
    /* display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    width: fit-content; */
    position: fixed;
}
.slidesContainer {
    overflow: hidden;
    width: 100%;
}
.slidesContainer .wrapperContPag {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    height: 200px;
    width: 55%;
    /* border: 4px solid red; */
    margin: 0 auto;
}
.slidesContainer .wrapperContPag .slidesInnerContainer {
    display: flex;
    align-items: center;
    height: 100%;
    /* gap: 1rem; */
    transition: transform 0.1s ease-in-out;
    margin-bottom: 32px;
    /* position: absolute; */
    position: relative;
    left: 170px;
}
.slidesContainer .wrapperContPag .slidesInnerContainer .slide {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(100% / 10);
    transition: opacity 0.3s ease-in-out;
    padding: 0 10px;
    min-width: 250px;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

#slide_activ{
    max-width: 314px;
}
/* .pagination {
    position: relative;
    display: flex;
    justify-content: center;
    margin-left: auto;
    margin-right: auto;
    width: 154px;
    overflow: hidden;
}
.pagination::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    background: #222426;
    background: linear-gradient(90deg, rgba(34, 36, 38, 1) 0%, rgba(255, 255, 255, 0) 50%, rgba(34, 36, 38, 1) 100%);
    z-index: 1;
}
.pagination .pagination_border {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: auto;
    margin-right: auto;
}
.pagination .pagination_dots {
    position: absolute;
    top: 0;
    left: 45.2%;
    display: flex;
    gap: 6px;
    height: 100%;
    align-items: center;
    overflow: hidden;
    transition: transform 0.9s ease;
}
.pagination .pagination_dots .activeDot {
    display: flex;
    align-items: center;
} */`, "",{"version":3,"sources":["webpack://./src/styles/slider.css"],"names":[],"mappings":"AAAA;IACI,sCAAsC;IACtC,gDAAgD;AACpD;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,UAAU;IACV,oBAAoB;IACpB,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,cAAc;IACd,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,6BAA6B;IAC7B,QAAQ;IACR,2BAA2B;IAC3B,eAAe;IACf,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,2CAA2C;AAC/C;AACA;IACI,qBAAqB;AACzB;AACA;IACI;;MAEE;AACN;AACA;IACI,iBAAiB;IACjB,UAAU;IACV,QAAQ;AACZ;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;AACd;;AAEA;IACI;;;;yBAIqB;IACrB,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,aAAa;IACb,UAAU;IACV,2BAA2B;IAC3B,cAAc;AAClB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,sCAAsC;IACtC,mBAAmB;IACnB,wBAAwB;IACxB,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,YAAyB;IAAzB,cAAyB;IAAzB,2BAAyB;IACzB,oCAAoC;IACpC,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA0CG","sourcesContent":[".contactsWrapper {\n    /* border-bottom: 1px solid #3ACABA; */\n    border-bottom: 1px solid var(--main-green-color);\n}\n.contactsWrapper_title {\n    display: flex;\n    justify-content: space-between;\n    padding-right: 32px;\n    margin-bottom: 16px;\n    width: 25%;\n    padding-bottom: 24px;\n    align-items: center;\n}\n.contactsWrapper_title h2 {\n    display: block;\n    color: #c2c7cc;\n    font-family: Open Sans;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 24px;\n}\n.slider {\n    position: relative;\n}\n.slider .prevArrow, .slider .nextArrow {\n    position: absolute;\n    /* fill: #3ACABA; */\n    fill: var(--main-green-color);\n    top: 50%;\n    transform: translateY(-50%);\n    font-size: 24px;\n    background: transparent;\n    border: none;\n    cursor: pointer;\n    transition: fill 0.3s ease, color 0.3s ease;\n}\n.slider .prevArrow:hover, .slider .nextArrow:hover {\n    fill: rgb(44, 45, 46);\n}\n@media (max-width: 768px) {\n    /* .slider .prevArrow, .slider .nextArrow {\n        display: none;\n   } */\n}\n.slider .prevArrow {\n    /* left: 370px; */\n    z-index: 1;\n    top: 45%;\n}\n.slider .nextArrow {\n    /* right: 420px; */\n    top: 45%;\n    z-index: 1;\n}\n\n.active_slide{\n    /* display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: flex-start;\n    width: fit-content; */\n    position: fixed;\n}\n.slidesContainer {\n    overflow: hidden;\n    width: 100%;\n}\n.slidesContainer .wrapperContPag {\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    height: 200px;\n    width: 55%;\n    /* border: 4px solid red; */\n    margin: 0 auto;\n}\n.slidesContainer .wrapperContPag .slidesInnerContainer {\n    display: flex;\n    align-items: center;\n    height: 100%;\n    /* gap: 1rem; */\n    transition: transform 0.1s ease-in-out;\n    margin-bottom: 32px;\n    /* position: absolute; */\n    position: relative;\n    left: 170px;\n}\n.slidesContainer .wrapperContPag .slidesInnerContainer .slide {\n    flex: 0 0 calc(100% / 10);\n    transition: opacity 0.3s ease-in-out;\n    padding: 0 10px;\n    min-width: 250px;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n#slide_activ{\n    max-width: 314px;\n}\n/* .pagination {\n    position: relative;\n    display: flex;\n    justify-content: center;\n    margin-left: auto;\n    margin-right: auto;\n    width: 154px;\n    overflow: hidden;\n}\n.pagination::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    pointer-events: none;\n    background: #222426;\n    background: linear-gradient(90deg, rgba(34, 36, 38, 1) 0%, rgba(255, 255, 255, 0) 50%, rgba(34, 36, 38, 1) 100%);\n    z-index: 1;\n}\n.pagination .pagination_border {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-left: auto;\n    margin-right: auto;\n}\n.pagination .pagination_dots {\n    position: absolute;\n    top: 0;\n    left: 45.2%;\n    display: flex;\n    gap: 6px;\n    height: 100%;\n    align-items: center;\n    overflow: hidden;\n    transition: transform 0.9s ease;\n}\n.pagination .pagination_dots .activeDot {\n    display: flex;\n    align-items: center;\n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
